import React from 'react'


export default function MailAction({ data }: any) {
  return (
    <div className='mail-status'>
      <span>{data && data.status}</span>
      {/* {data && data.scheduledTime && <MailDate dateTime={data.scheduledTime} />} */}
    </div>
  )
}
